import { createConfig, http } from "wagmi";
import { bsc, bscTestnet } from "wagmi/chains";
import { walletConnect } from "wagmi/connectors";

// WalletConnect project ID — replace with your own from https://cloud.walletconnect.com
export const WALLETCONNECT_PROJECT_ID =
  import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || "YOUR_PROJECT_ID";

export const config = createConfig({
  chains: [bsc, bscTestnet],
  connectors: [walletConnect({ projectId: WALLETCONNECT_PROJECT_ID })],
  transports: {
    [bsc.id]: http(
      import.meta.env.VITE_BSC_RPC_URL || "https://bsc-dataseed1.binance.org",
    ),
    [bscTestnet.id]: http(
      import.meta.env.VITE_BSC_TESTNET_RPC_URL ||
        "https://data-seed-prebsc-1-s1.binance.org:8545",
    ),
  },
});
